<template>
  <div
    class="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow"
  >
    <!-- En-tête du document -->
    <div class="p-4 bg-white border-b border-gray-200">
      <div class="flex items-start justify-between">
        <div class="flex items-start gap-3 flex-1 min-w-0">
          <div class="shrink-0 mt-1" aria-hidden="true">
            <svg class="w-8 h-8 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
              />
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <p
              class="text-sm font-semibold text-gray-900 truncate"
              :title="document.name"
            >
              {{ document.name }}
            </p>
            <p class="text-xs text-gray-500 mt-1">
              {{ document.ext.toUpperCase() || 'FICHIER' }}
            </p>
          </div>
        </div>
        <a
          :href="document.url"
          :download="document.name"
          target="_blank"
          rel="noopener noreferrer"
          class="shrink-0 ml-2 p-2 text-gray-500 hover:text-[#04406E] transition-colors"
          :title="`Télécharger ${document.name}`"
          aria-label="Télécharger le fichier"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </a>
      </div>
    </div>

    <!-- Corps générique -->
    <div class="bg-gray-100 aspect-video flex items-center justify-center">
      <div class="text-center p-4">
        <p class="text-sm text-gray-600">
          Fichier {{ document.ext.toUpperCase() || 'joint' }}
        </p>
        <a
          :href="document.url"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block mt-2 px-4 py-2 bg-[#04406E] text-white rounded-lg text-sm hover:bg-[#033a5a] transition-colors"
        >
          Ouvrir
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface AttachmentDocument {
  url: string
  name: string
  ext: string
  type: string
  index: number
}

defineProps<{
  document: AttachmentDocument
}>()
</script>

